/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import SympathyCremationFactsBlock from './SympathyCremationFactsBlock';
import Data from './ViewData';

const SympathyCremationFactsPage = () => (<SympathyCremationFactsBlock data={Data} />);

export default SympathyCremationFactsPage;
